import ForgottenPasswordPage from './ForgottenPasswordPage';

export default ForgottenPasswordPage;
